<template>
  <!-- safari浏览器提示 -->
  <div class="container">
    <div class="maskSafari">
      <div class="bgSafari">
        <div class="headStyle"></div>
        <span class="headText" @click="closeText">注意</span>
        <div class="infoSvg"></div>
        <span class="textStyle">
          {{ isSafari }}
          在音频创新领域中，它并不是最佳选择。体验WANOS互动式音频的不同之处，请使用
          Chrome 、 Edge 等基于 Chromium 的浏览器。
        </span>
        <div class="bottomBorder"></div>
        <div class="bottomText">2022-2032 © All Right Reserved by WANOS</div>
        <div class="buttonStyle" @click="closeText">继续体验</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

export default {
  name: "StopSafariCom",
  props: [],
  data() {
    return {};
  },
  components: {},
  mounted() {},
  methods: {
    // 关闭safari浏览器提示
    ...mapMutations(["geSafari"]),
    closeText() {
      this.geSafari(false);
    },
  },
  watch: {},
  computed: {
    ...mapState(["isSafari"]),
  },
};
</script>
<style scoped>
* {
  margin: 0;
  padding: 0;
}
.maskSafari {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 100000;
}
.bgSafari {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 35%;
  width: 642px;
  height: 235px;

  background: #21242b;
  box-shadow: 0px 6px 14px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}
.headStyle {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 42px;
  background: #2b2f37;
  border-bottom: 1px solid #16191d;
}
.headText {
  position: absolute;
  left: 20px;
  font-family: "PingFang SC";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 42px;

  color: #bbc8e5;
}
.closeStyle {
  position: absolute;
  top: 15px;
  right: 30px;
  color: rgb(16, 106, 185);
  font-size: 16px;
  cursor: pointer;
}
.infoSvg {
  position: absolute;
  top: 97px;
  left: 71px;
  width: 30px;
  height: 30px;

  background-image: url("/space/images/info.svg");
  background-repeat: no-repeat;
  background-size: contain;
}
.textStyle {
  position: absolute;
  top: 92px;
  left: 121px;
  width: 452px;
  height: 40px;
  font-family: "PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  color: #bbc8e5;
}
.bottomBorder {
  position: absolute;
  bottom: 57px;
  left: 0;
  width: 100%;
  border-bottom: 1px solid #16191d;
}
.bottomText {
  position: absolute;
  bottom: 19.5px;
  left: 20px;
  font-family: "PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #727c94;
  opacity: 0.6;
}
.buttonStyle {
  position: absolute;
  bottom: 14px;
  right: 20px;
  width: 88px;
  height: 29px;
  background: linear-gradient(180deg, #3d3dfc -12.5%, #1c1cb7 163.24%);
  box-shadow: inset 0px 1px 0px rgba(255, 255, 255, 0.16);
  border-radius: 4px;

  font-family: "PingFang SC";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 29px;
  text-align: center;
  color: #bbc8e5;

  cursor: pointer;
  z-index: 100001;
}
</style>
